import { createAmazonApiInstance, createUploadFileFleetApiInstanceWithToken} from '../util';

const general = {
    uploadFile: ({ url, file, contentType, onUploadProgress }) => {
        return createAmazonApiInstance(url, {
            'Content-Type': contentType ?? file.type,
        }).put('', file, {
            onUploadProgress
        });
    },
    importFileByPOST: ({url, file}) => {
        return createUploadFileFleetApiInstanceWithToken().post(url, file);
    },
};

export default general;
